export const ORDER_READ = "ORDER_READ";
export const ORDER_CREATE = "ORDER_CREATE";
export const ORDER_EDIT = "ORDER_EDIT";
export const ORDER_DATA_WRITE = "ORDER_DATA_WRITE";
export const ORDER_DATA_READ = "ORDER_DATA_READ";
export const ORDER_CONTRACTOR_WRITE = "ORDER_CONTRACTOR_WRITE";
export const ORDER_CONTRACTOR_READ = "ORDER_CONTRACTOR_READ";
export const ORDER_CONTRACTOR_PAYMENT_DATE_WRITE =
  "ORDER_CONTRACTOR_PAYMENT_DATE_WRITE";
export const ORDER_CONTRACTOR_PAYMENT_DATE_READ =
  "ORDER_CONTRACTOR_PAYMENT_DATE_READ";
export const ORDER_CARRIER_WRITE = "ORDER_CARRIER_WRITE";
export const ORDER_CARRIER_READ = "ORDER_CARRIER_READ";
export const ORDER_CARRIER_PAYMENT_DATE_WRITE =
  "ORDER_CARRIER_PAYMENT_DATE_WRITE";
export const ORDER_CARRIER_PAYMENT_DATE_READ =
  "ORDER_CARRIER_PAYMENT_DATE_READ";
export const ORDER_ADDITIONAL_INFO_WRITE = "ORDER_ADDITIONAL_INFO_WRITE";
export const ORDER_ADDITIONAL_INFO_READ = "ORDER_ADDITIONAL_INFO_READ";
export const ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_WRITE =
  "ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_WRITE";
export const ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_READ =
  "ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_READ";
export const ORDER_ATTACHMENTS_CARGO_PHOTOS_WRITE =
  "ORDER_ATTACHMENTS_CARGO_PHOTOS_WRITE";
export const ORDER_ATTACHMENTS_CARGO_PHOTOS_READ =
  "ORDER_ATTACHMENTS_CARGO_PHOTOS_READ";
export const ORDER_ATTACHMENTS_OTHER_DOCUMENTS_WRITE =
  "ORDER_ATTACHMENTS_OTHER_DOCUMENTS_WRITE";
export const ORDER_ATTACHMENTS_OTHER_DOCUMENTS_READ =
  "ORDER_ATTACHMENTS_OTHER_DOCUMENTS_READ";
export const ORDER_ATTACHMENTS_CONFIRMATION_WRITE =
  "ORDER_ATTACHMENTS_CONFIRMATION_WRITE";
export const ORDER_ATTACHMENTS_CONFIRMATION_READ =
  "ORDER_ATTACHMENTS_CONFIRMATION_READ";
export const ORDER_DELIVERY_POINT_WRITE = "ORDER_DELIVERY_POINT_WRITE";
export const ORDER_DELIVERY_POINT_READ = "ORDER_DELIVERY_POINT_READ";
export const ORDER_FORWARDER_WRITE = "ORDER_FORWARDER_WRITE";
export const ORDER_FORWARDER_READ = "ORDER_FORWARDER_READ";
export const ORDER_DISPATCHER_WRITE = "ORDER_DISPATCHER_WRITE";
export const ORDER_DISPATCHER_READ = "ORDER_DISPATCHER_READ";
export const ORDER_INCOME_WRITE = "ORDER_INCOME_WRITE";
export const ORDER_INCOME_READ = "ORDER_INCOME_READ";
export const ORDER_COST_WRITE = "ORDER_COST_WRITE";
export const ORDER_COST_READ = "ORDER_COST_READ";
export const ORDER_TRANSACTION_PAYMENT_DATE_WRITE =
  "ORDER_TRANSACTION_PAYMENT_DATE_WRITE";
export const ORDER_TRANSACTION_PAYMENT_DATE_READ =
  "ORDER_TRANSACTION_PAYMENT_DATE_READ";
export const ORDER_REPORT_SETTINGS_WRITE = "ORDER_REPORT_SETTINGS_WRITE";
export const ORDER_REPORT_SETTINGS_READ = "ORDER_REPORT_SETTINGS_READ";
export const ORDER_APPROVE_FOR_FULFILLMENT = "ORDER_APPROVE_FOR_FULFILLMENT";

export const ORDER_DELETE = "ORDER_DELETE";
export const ORDER_EXTERNAL_ORDERS = "ORDER_EXTERNAL_ORDERS";
export const ORDER_STATUS_CHANGE_BASED_ON_DRIVER_ACTIVITY =
  "ORDER_STATUS_CHANGE_BASED_ON_DRIVER_ACTIVITY";
export const ORDER_STATUS_CHANGE = "ORDER_STATUS_CHANGE";
export const ORDER_HISTORY_READ = "ORDER_HISTORY_READ";
export const ORDER_HISTORY_WRITE = "ORDER_HISTORY_WRITE";

export const CAR_READ = "CAR_READ";
export const CAR_CREATE = "CAR_CREATE";
export const CAR_EDIT = "CAR_EDIT";
export const CAR_CONTRACTOR_WRITE = "CAR_CONTRACTOR_WRITE";
export const CAR_CONTRACTOR_READ = "CAR_CONTRACTOR_READ";
export const CAR_DATA_WRITE = "CAR_DATA_WRITE";
export const CAR_DATA_READ = "CAR_DATA_READ";
export const CAR_DRIVER_WRITE = "CAR_DRIVER_WRITE";
export const CAR_DRIVER_READ = "CAR_DRIVER_READ";
export const CAR_ATTACHMENTS_WRITE = "CAR_ATTACHMENTS_WRITE";
export const CAR_ATTACHMENTS_READ = "CAR_ATTACHMENTS_READ";
export const CAR_DELETE = "CAR_DELETE";

export const DRIVER_READ = "DRIVER_READ";
export const DRIVER_CREATE = "DRIVER_CREATE";
export const DRIVER_EDIT = "DRIVER_EDIT";
export const DRIVER_CARRIER_WRITE = "DRIVER_CARRIER_WRITE";
export const DRIVER_CARRIER_READ = "DRIVER_CARRIER_READ";
export const DRIVER_DATA_WRITE = "DRIVER_DATA_WRITE";
export const DRIVER_DATA_READ = "DRIVER_DATA_READ";
export const DRIVER_ADDITIONAL_DATA_WRITE = "DRIVER_ADDITIONAL_DATA_WRITE";
export const DRIVER_ADDITIONAL_DATA_READ = "DRIVER_ADDITIONAL_DATA_READ";
export const DRIVER_ACCOUNT_WRITE = "DRIVER_ACCOUNT_WRITE";
export const DRIVER_ACCOUNT_READ = "DRIVER_ACCOUNT_READ";
export const DRIVER_ATTACHMENTS_WRITE = "DRIVER_ATTACHMENTS_WRITE";
export const DRIVER_ATTACHMENTS_READ = "DRIVER_ATTACHMENTS_READ";
export const DRIVER_DELETE = "DRIVER_DELETE";

export const USER_READ = "USER_READ";
export const USER_CREATE = "USER_CREATE";
export const USER_EDIT = "USER_EDIT";
export const USER_DATA_WRITE = "USER_DATA_WRITE";
export const USER_DATA_READ = "USER_DATA_READ";
export const USER_ACCOUNT_WRITE = "USER_ACCOUNT_WRITE";
export const USER_ACCOUNT_READ = "USER_ACCOUNT_READ";
export const USER_DELETE = "USER_DELETE";

export const FERRY_SERVICE_READ = "FERRY_SERVICE_READ";
export const FERRY_SERVICE_CREATE = "FERRY_SERVICE_CREATE";
export const FERRY_SERVICE_EDIT = "FERRY_SERVICE_EDIT";
export const FERRY_SERVICE_CONTRACTOR_WRITE = "FERRY_SERVICE_CONTRACTOR_WRITE";
export const FERRY_SERVICE_CONTRACTOR_READ = "FERRY_SERVICE_CONTRACTOR_READ";
export const FERRY_SERVICE_DATA_WRITE = "FERRY_SERVICE_DATA_WRITE";
export const FERRY_SERVICE_DATA_READ = "FERRY_SERVICE_DATA_READ";
export const FERRY_SERVICE_ADDITIONAL_DATA_WRITE =
  "FERRY_SERVICE_ADDITIONAL_DATA_WRITE";
export const FERRY_SERVICE_ADDITIONAL_DATA_READ =
  "FERRY_SERVICE_ADDITIONAL_DATA_READ";
export const FERRY_SERVICE_DELETE = "FERRY_SERVICE_DELETE";

export const CONTRACTOR_READ = "CONTRACTOR_READ";
export const CONTRACTOR_CREATE = "CONTRACTOR_CREATE";
export const CONTRACTOR_EDIT = "CONTRACTOR_EDIT";
export const CONTRACTOR_DATA_WRITE = "CONTRACTOR_DATA_WRITE";
export const CONTRACTOR_DATA_READ = "CONTRACTOR_DATA_READ";
export const CONTRACTOR_ADDRESS_WRITE = "CONTRACTOR_ADDRESS_WRITE";
export const CONTRACTOR_ADDRESS_READ = "CONTRACTOR_ADDRESS_READ";
export const CONTRACTOR_CORRESPONDENCE_WRITE =
  "CONTRACTOR_CORRESPONDENCE_WRITE";
export const CONTRACTOR_CORRESPONDENCE_READ = "CONTRACTOR_CORRESPONDENCE_READ";
export const CONTRACTOR_ADDITIONAL_DATA_WRITE =
  "CONTRACTOR_ADDITIONAL_DATA_WRITE";
export const CONTRACTOR_ADDITIONAL_DATA_READ =
  "CONTRACTOR_ADDITIONAL_DATA_READ";
export const CONTRACTOR_FINANCE_DATA_READ = "CONTRACTOR_FINANCE_DATA_READ";
export const CONTRACTOR_INCOME_PAYMENT_DUE_DATE_WRITE =
  "CONTRACTOR_INCOME_PAYMENT_DUE_DATE_WRITE";
export const CONTRACTOR_INCOME_PAYMENT_DUE_DATE_READ =
  "CONTRACTOR_INCOME_PAYMENT_DUE_DATE_READ";
export const CONTRACTOR_COST_PAYMENT_DUE_DATE_WRITE =
  "CONTRACTOR_COST_PAYMENT_DUE_DATE_WRITE";
export const CONTRACTOR_COST_PAYMENT_DUE_DATE_READ =
  "CONTRACTOR_COST_PAYMENT_DUE_DATE_READ";
export const CONTRACTOR_DEBT_LIMIT_WRITE = "CONTRACTOR_DEBT_LIMIT_WRITE";
export const CONTRACTOR_DEBT_LIMIT_READ = "CONTRACTOR_DEBT_LIMIT_READ";
export const CONTRACTOR_CURRENCY_WRITE = "CONTRACTOR_CURRENCY_WRITE";
export const CONTRACTOR_CURRENCY_READ = "CONTRACTOR_CURRENCY_READ";
export const CONTRACTOR_ATTACHMENTS_WRITE = "CONTRACTOR_ATTACHMENTS_WRITE";
export const CONTRACTOR_ATTACHMENTS_READ = "CONTRACTOR_ATTACHMENTS_READ";
export const CONTRACTOR_ROLES_WRITE = "CONTRACTOR_ROLES_WRITE";
export const CONTRACTOR_ROLES_READ = "CONTRACTOR_ROLES_READ";
export const CONTRACTOR_HISTORY_READ = "CONTRACTOR_HISTORY_READ";
export const CONTRACTOR_DELETE = "CONTRACTOR_DELETE";

export const CONTRACTOR_POLICY_READ = "CONTRACTOR_POLICY_READ";
export const CONTRACTOR_POLICY_CREATE = "CONTRACTOR_POLICY_CREATE";
export const CONTRACTOR_POLICY_EDIT = "CONTRACTOR_POLICY_EDIT";
export const CONTRACTOR_POLICY_DATA_WRITE = "CONTRACTOR_POLICY_DATA_WRITE";
export const CONTRACTOR_POLICY_DATA_READ = "CONTRACTOR_POLICY_DATA_READ";
export const CONTRACTOR_POLICY_CONTRIBUTIONS_WRITE =
  "CONTRACTOR_POLICY_CONTRIBUTIONS_WRITE";
export const CONTRACTOR_POLICY_CONTRIBUTIONS_READ =
  "CONTRACTOR_POLICY_CONTRIBUTIONS_READ";
export const CONTRACTOR_POLICY_ATTACHMENTS_WRITE =
  "CONTRACTOR_POLICY_ATTACHMENTS_WRITE";
export const CONTRACTOR_POLICY_ATTACHMENTS_READ =
  "CONTRACTOR_POLICY_ATTACHMENTS_READ";
export const CONTRACTOR_POLICY_DELETE = "CONTRACTOR_POLICY_DELETE";

export const USER_GROUP_READ = "USER_GROUP_READ";
export const USER_GROUP_CREATE = "USER_GROUP_CREATE";
export const USER_GROUP_EDIT = "USER_GROUP_EDIT";
export const USER_GROUP_DELETE = "USER_GROUP_DELETE";

export const GROUP_READ = "GROUP_READ";
export const GROUP_CREATE = "GROUP_CREATE";
export const GROUP_EDIT = "GROUP_EDIT";
export const GROUP_DATA_WRITE = "GROUP_DATA_WRITE";
export const GROUP_DELETE = "GROUP_DELETE";

export const CUSTOM_FIELDS_READ = "CUSTOM_FIELDS_READ";
export const CUSTOM_FIELDS_CREATE = "CUSTOM_FIELDS_CREATE";
export const CUSTOM_FIELDS_EDIT = "CUSTOM_FIELDS_EDIT";

export const MY_PROFILE_READ = "MY_PROFILE_READ";
export const MY_PROFILE_WRITE = "MY_PROFILE_WRITE";

export const GLOBAL_CONFIGURATION_WRITE = "GLOBAL_CONFIGURATION_WRITE";
